<template>
	<div class="five">
		<div class="container">
			<div class="content">
				<i class="el-icon-refresh"></i>暂时没有更多信息显示
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'two'
			}
		},
		
	}
</script>

<style lang="less" scoped="scoped">
.five{
	margin-bottom: 100px;
	.content{
		font-size: 20px;
		text-align: center;
		margin-top: 80px;
		margin-bottom: 30px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Solution/Scom/Five.vue